import gql from 'graphql-tag'

export const GET_CONTACTS = gql`
  query contacts($partyId: uuid!){
    contacts (where:{clientid:{_eq:$partyId}})
    {
      name
      mobile
      role
      email
      id
    }
  }
`
export const GET_CONTACTS_AND_USERS = gql`
  query contactsAndUsers($partyId: uuid!){
    contacts(where:{clientid:{_eq:$partyId}})
    {
      name
      mobile
      role
      email
      id
    }
    users: CompnayUser(where:{clientid:{_eq:$partyId}})
    {
      name
      mobile
      role
      email
      id
    }
  }
`

export const GET_CONTACTS_OF_ADDRESSBOOK = gql`
  query addressbookedcontacts($partyId: uuid!){
    contacts: addressbookedcontacts (where:{clientid:{_eq:$partyId}})
    {
      name
      mobile
      role
      id
    }
  }
`
export const GET_CONTACT_BY_ID = gql`
  query addressbookedcontacts($id: uuid!){
    contacts: addressbookedcontacts (where:{id:{_eq:$id}})
    {
      name
      mobile
      role
      id
    }
  }
`
export const GET_COMPANY_USER_BY_MOBILE = gql`
  query companyUsers($mobileArr: [String!]){
    companyUsers: CompnayUser (where:{mobile:{_in:$mobileArr}})
    {
      id
      mobile
    }
  }
`
